import React, { useState } from "react";

const roles = [
    "🌍 Farm Regional Co-ordinator",
    "📍Area Co-ordinator",
    "🔗Cluster Co-ordinator",
    "🌱Farmer",
    "🏆Think5Whys Aggregator (Self Employment)",
    "👨‍🌾Workers",
    "📦Agri Stockist",
    "🏬Agri Retailer",
    "🛒Other Sellers",
    "🚚Logistic",
    "📦Storage Service",
    "🚢Export-Import",
    "🍽️Food Business",
    "🚮Waste Disposer",
    "🤝NGO",
    "🏢Corporate",
    "📚Agri Scholar",
    "🚁Drone Operators",
    "🧑‍🔬Expert",
    "🐄Vet Doctor",
  ];

const faqData = {
  "🌍 Farm Regional Co-ordinator": [
    // Negative
    {
      sentiment: "negative",
      question: "How can I manage coordination across vast regions with limited resources?",
      answer:
        "AgriLink's Data-Driven Insights provide real-time maps and alerts, helping you prioritize without extra staff—focus on high-impact areas first.",
    },
    {
      sentiment: "negative",
      question: "Will this platform handle diverse regional challenges effectively?",
      answer:
        "Customizable for climates, crops, and local schemes—AI adapts to your region's unique needs, reducing guesswork.",
    },
    {
      sentiment: "negative",
      question: "Is it secure for sharing regional data with teams?",
      answer:
        "Role-based access and encryption ensure only authorized views—protect your strategies and farmer info.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Can I integrate regional government schemes?",
      answer:
        "Yes, links to AgriLoan and insurance programs with automated reporting for compliance.",
    },
    {
      sentiment: "neutral",
      question: "How do I track team performance?",
      answer:
        "Dashboards show attendance, task completion, and SAKSHAM Ranking for regional teams.",
    },
    {
      sentiment: "neutral",
      question: "What reports are available for regional overviews?",
      answer:
        "Exportable summaries on yields, incomes, and events by district or state.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How can it boost regional productivity?",
      answer:
        "Community Events and Workshops scale learning, increasing yields by 15-20% in pilot regions.",
    },
    {
      sentiment: "positive",
      question: "Will AI help forecast regional risks?",
      answer:
        "Predicts weather, market dips, and supply issues—proactive planning for stability.",
    },
    {
      sentiment: "positive",
      question: "Can it connect me to corporate partners?",
      answer:
        "Community Impact tools facilitate CSR tie-ups for funding and tech support.",
    },
  ],
  "📍 Area Co-ordinator": [
    // Negative
    {
      sentiment: "negative",
      question: "Dealing with fragmented local communications is overwhelming—does this help?",
      answer:
        "Centralized chat and alerts via AgriLink unify teams and farmers—cut coordination time in half.",
    },
    {
      sentiment: "negative",
      question: "What if local adoption is low due to tech fears?",
      answer:
        "Voice-guided onboarding and demos build confidence—rural-friendly from the start.",
    },
    {
      sentiment: "negative",
      question: "Can it handle urgent local emergencies?",
      answer:
        "Quick alerts for pests or weather, with Nearby Deals for immediate supplies.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How do I monitor area-specific deals?",
      answer:
        "Live feeds of Unity Deals and enquiries, filtered by your locality.",
    },
    {
      sentiment: "neutral",
      question: "Is training for area teams included?",
      answer:
        "Free Agri Workshops and Podcasts tailored to local crops.",
    },
    {
      sentiment: "neutral",
      question: "Can I assign tasks to locals?",
      answer:
        "Task & Management tools with geo-fencing for attendance and logs.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How does it enhance local engagement?",
      answer:
        "POV Debates and Events foster community buy-in, boosting participation.",
    },
    {
      sentiment: "positive",
      question: "Will it increase area incomes?",
      answer:
        "Digital Income referrals and Marketplace sales lift local earnings quickly.",
    },
    {
      sentiment: "positive",
      question: "Can I showcase area successes?",
      answer:
        "Recognition & Progress leaderboards highlight top performers regionally.",
    },
  ],
  "🔗 Cluster Co-ordinator": [
    // Negative
    {
      sentiment: "negative",
      question: "Managing shared resources in clusters leads to conflicts—how to avoid?",
      answer:
        "Contract Farming and Rental tools allocate fairly with AI mediation—peaceful collaborations.",
    },
    {
      sentiment: "negative",
      question: "Is scaling clusters digitally feasible?",
      answer:
        "Step-by-step guides and templates make it simple, even for small groups.",
    },
    {
      sentiment: "negative",
      question: "What about resolving cluster disputes?",
      answer:
        "Complaints module with neutral AI summaries speeds fair resolutions.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Can I track cluster resource usage?",
      answer:
        "Real-time logs for rentals, storage, and logistics sharing.",
    },
    {
      sentiment: "neutral",
      question: "How to organize cluster meetings?",
      answer:
        "Event-Flow for virtual/in-person scheduling with RSVPs.",
    },
    {
      sentiment: "neutral",
      question: "Does it support cluster financing?",
      answer:
        "Group AgriLoan applications with shared guarantees.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How can it strengthen cluster bonds?",
      answer:
        "Immersive Presentations and Forums build trust and idea-sharing.",
    },
    {
      sentiment: "positive",
      question: "Will it optimize cluster yields?",
      answer:
        "Data Insights recommend shared best practices for collective gains.",
    },
    {
      sentiment: "positive",
      question: "Can clusters access innovations together?",
      answer:
        "Group access to Digital Twin and Drone Operators for cost-sharing.",
    },
  ],
  "🌱 Farmer": [
    // Negative
    {
      sentiment: "negative",
      question: "Do I really have the time to use this platform with my busy farm schedule?",
      answer:
        "You don’t need to spend hours. AgriLink offers quick, voice-enabled tools and daily bite-sized insights—perfect for checking markets or loans in under 5 minutes while working.",
    },
    {
      sentiment: "negative",
      question: "Why should I trust this digital platform when I’ve always relied on local mandis?",
      answer:
        "AgriLink connects you directly to verified buyers and fair prices, reducing middlemen cuts. Thousands of farmers have sold more and earned better—it's your digital mandi, trusted by the community.",
    },
    {
      sentiment: "negative",
      question: "How can someone like me, with limited smartphone skills, use AgriLink?",
      answer:
        "It's designed for you: simple icons, voice commands, and offline access. No tech expertise needed—start with one tap to check crop prices or find nearby jobs.",
    },
    {
      sentiment: "negative",
      question: "If apps like Google exist, why AgriLink?",
      answer:
        "Google shows general info; AgriLink gives personalized agri advice, like crop-specific loans or local deals, based on your farm data and region.",
    },
    {
      sentiment: "negative",
      question: "Will this really help my income, or is it just hype?",
      answer:
        "Real results: Farmers using AgriLink report 20-30% higher sales via Marketplace and rewards from videos/ads. Track your earnings growth right on the dashboard.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "What kind of daily tools does AgriLink offer for farmers?",
      answer:
        "Daily life logs, attendance tracking, crop price alerts, and simple loan/insurance applications—all in one easy app.",
    },
    {
      sentiment: "neutral",
      question: "Is there a mobile app, or just web?",
      answer:
        "Full mobile app for Android/iOS, optimized for rural networks with offline mode. Web for detailed reports.",
    },
    {
      sentiment: "neutral",
      question: "Can I track my farm's progress over time?",
      answer:
        "Yes, dashboards show yield trends, income growth, and SAKSHAM Ranking updates monthly.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How can AgriLink boost my farm income?",
      answer:
        "Access Digital Income via rewarding videos, referrals, and direct sales in Marketplace—many see extra earnings in weeks.",
    },
    {
      sentiment: "positive",
      question: "Will it help me get quick loans or insurance?",
      answer:
        "AI prepares your docs and matches you to schemes like AgriLoan—approvals faster than traditional banks.",
    },
    {
      sentiment: "positive",
      question: "Can I learn new farming techniques easily?",
      answer:
        "Bite-sized workshops, podcasts, and AI counselling on everything from vertical farming to pest control—no classroom needed.",
    },
  ],
  "🏆 Think5Whys Aggregator (Self Employment)": [
    // Negative
    {
      sentiment: "negative",
      question: "Starting self-employment in agri feels risky—does this support it?",
      answer:
        "Low-barrier entry with templates and mentorship—turn ideas into income with minimal investment.",
    },
    {
      sentiment: "negative",
      question: "How to find clients without a network?",
      answer:
        "Marketplace listings and Refer programs connect you instantly to farmers and buyers.",
    },
    {
      sentiment: "negative",
      question: "Is scaling self-employment sustainable?",
      answer:
        "Track growth with Analytics, access group loans for expansion.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "What services can I aggregate?",
      answer:
        "From drone ops to waste management—bundle and sell via platform.",
    },
    {
      sentiment: "neutral",
      question: "How to manage self-employment taxes?",
      answer:
        "Integrated compliance tools for GST and filings.",
    },
    {
      sentiment: "neutral",
      question: "Can I track my aggregator portfolio?",
      answer:
        "Dashboard for client metrics and earnings overview.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How does it empower self-starters?",
      answer:
        "Innovation hub spotlights your services, driving leads.",
    },
    {
      sentiment: "positive",
      question: "Will it help diversify income?",
      answer:
        "Multi-stream opportunities from reselling to events.",
    },
    {
      sentiment: "positive",
      question: "Can I build a personal brand?",
      answer:
        "Recognition tools showcase your aggregator success stories.",
    },
  ],
  "👨‍🌾 Workers": [
    // Negative
    {
      sentiment: "negative",
      question: "Job hunting in farms is inconsistent—how does this fix it?",
      answer:
        "Bluehands lists verified gigs with ratings—steady work alerts daily.",
    },
    {
      sentiment: "negative",
      question: "Low pay for hard labor—any change?",
      answer:
        "Rewarding tasks and bonuses via platform boost earnings 10-15%.",
    },
    {
      sentiment: "negative",
      question: "Tracking hours without disputes?",
      answer:
        "Digital attendance with geo-proof—fair pay, no arguments.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "What types of farm jobs are available?",
      answer:
        "Harvesting, planting, maintenance—filtered by location and skill.",
    },
    {
      sentiment: "neutral",
      question: "How to apply for jobs?",
      answer:
        "One-tap applications with profile matching.",
    },
    {
      sentiment: "neutral",
      question: "Can I rate employers?",
      answer:
        "Feedback system ensures safe, fair work environments.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How can it upskill me for better jobs?",
      answer:
        "Free Digital Learning modules on machinery and safety.",
    },
    {
      sentiment: "positive",
      question: "Will it connect me to urban opportunities?",
      answer:
        "Links to Logistics and Export roles beyond farms.",
    },
    {
      sentiment: "positive",
      question: "Can I earn extras?",
      answer:
        "Side gigs like Rewarding Videos during breaks.",
    },
  ],
  "📦 Agri Stockist": [
    // Negative
    {
      sentiment: "negative",
      question: "Volatile markets ruin stock planning—help?",
      answer:
        "Price forecasts and alerts prevent overstocking—smarter buys.",
    },
    {
      sentiment: "negative",
      question: "Storage spoilage is costly—solutions?",
      answer:
        "Partner with Storage Services for climate-controlled options.",
    },
    {
      sentiment: "negative",
      question: "Slow sales in off-seasons?",
      answer:
        "Promote via Marketplace to wider buyers year-round.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How to track inventory digitally?",
      answer:
        "Auto-sync with Catalogue for real-time stock levels.",
    },
    {
      sentiment: "neutral",
      question: "Can I handle bulk packaging?",
      answer:
        "Agriproducts Packaging module with supplier links.",
    },
    {
      sentiment: "neutral",
      question: "What about supplier enquiries?",
      answer:
        "Central hub for quotes and negotiations.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to expand my stockist business?",
      answer:
        "Access Wholesale and Export for larger volumes.",
    },
    {
      sentiment: "positive",
      question: "Will it improve margins?",
      answer:
        "Direct deals cut costs, boosting profits 20%.",
    },
    {
      sentiment: "positive",
      question: "Can I get loyalty from farmers?",
      answer:
        "Rewards programs tie buyers to your stock.",
    },
  ],
  "🏬 Agri Retailer": [
    // Negative
    {
      sentiment: "negative",
      question: "How can I trust supplier quality on this platform?",
      answer:
        "AgriLink verifies farmers via digital cards and ratings—plus, traceability tools ensure fresh, reliable stock every time.",
    },
    {
      sentiment: "negative",
      question: "Will this reduce my dependency on wholesalers, or add more hassle?",
      answer:
        "It cuts middlemen with direct Nearby Deals and Unity Deals, saving costs without extra work—streamline your sourcing in minutes.",
    },
    {
      sentiment: "negative",
      question: "Is the platform secure for my business transactions?",
      answer:
        "Bank-grade encryption and secure payments protect your data and deals—trusted by retailers nationwide.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Can AgriLink integrate with my current inventory system?",
      answer:
        "Yes, simple APIs connect to your POS or spreadsheets for seamless stock updates.",
    },
    {
      sentiment: "neutral",
      question: "How often do deals and prices update?",
      answer: "Real-time updates with daily alerts for new stock and price changes.",
    },
    {
      sentiment: "neutral",
      question: "Can I generate sales reports easily?",
      answer:
        "Exportable reports on sales, trends, and customer insights in PDF/Excel.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How can it increase my customer footfall?",
      answer:
        "Promote via Agri Events and Immersive Presentations—drive more locals with targeted deals.",
    },
    {
      sentiment: "positive",
      question: "Will it help with loyalty programs?",
      answer:
        "Integrate Kharcho Jeeto rewards to keep customers coming back and spending more.",
    },
    {
      sentiment: "positive",
      question: "Can I expand to online sales?",
      answer:
        "Yes, list on Marketplace for wider reach, including urban buyers via Import-Export.",
    },
  ],
  "🛒 Other Sellers": [
    // Negative
    {
      sentiment: "negative",
      question: "Niche products hard to sell—visibility issue?",
      answer:
        "Catalogue spotlights unique items with targeted buyer matches.",
    },
    {
      sentiment: "negative",
      question: "Pricing negotiations take forever?",
      answer:
        "AI suggests fair prices based on market data—instant proposals.",
    },
    {
      sentiment: "negative",
      question: "What if buyers back out?",
      answer:
        "Secure payments and ratings build trust for smooth closes.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How to list custom products?",
      answer:
        "Easy upload with photos and descriptions—live in hours.",
    },
    {
      sentiment: "neutral",
      question: "Can I bundle with services?",
      answer:
        "Yes, combine with Rental or Expert consultations.",
    },
    {
      sentiment: "neutral",
      question: "Tracking sales analytics?",
      answer:
        "Dashboard shows buyer trends and repeat rates.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to reach premium buyers?",
      answer:
        "Export-Import connects to international markets.",
    },
    {
      sentiment: "positive",
      question: "Will it gamify my sales?",
      answer:
        "Contests like Aalu Dalo reward top sellers.",
    },
    {
      sentiment: "positive",
      question: "Can I collaborate with others?",
      answer:
        "Unity Deals for joint selling power.",
    },
  ],
  "🚚 Logistic": [
    // Negative
    {
      sentiment: "negative",
      question: "Perishables spoil in transit—how to prevent?",
      answer:
        "Temp-monitored routes and Quick Delivery minimize risks.",
    },
    {
      sentiment: "negative",
      question: "Route planning is inefficient?",
      answer:
        "AI optimizes paths, saving fuel and time 25%.",
    },
    {
      sentiment: "negative",
      question: "Payment delays from clients?",
      answer:
        "Escrow holds funds until delivery confirmed.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Integrate with farm pickups?",
      answer:
        "Geo-scheduled collections from clusters.",
    },
    {
      sentiment: "neutral",
      question: "Track multiple loads?",
      answer:
        "Live GPS for fleet and cargo status.",
    },
    {
      sentiment: "neutral",
      question: "Handle complaints?",
      answer:
        "Automated resolution with proof uploads.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to expand routes?",
      answer:
        "Partner with Storage for nationwide coverage.",
    },
    {
      sentiment: "positive",
      question: "Will it reduce costs?",
      answer:
        "Load-sharing with other sellers optimizes hauls.",
    },
    {
      sentiment: "positive",
      question: "Can I earn rewards?",
      answer:
        "Milestone bonuses for on-time deliveries.",
    },
  ],
  "📦 Storage Service": [
    // Negative
    {
      sentiment: "negative",
      question: "Peak season overloads capacity?",
      answer:
        "Dynamic booking with overflow partners—never full.",
    },
    {
      sentiment: "negative",
      question: "Quality control for stored goods?",
      answer:
        "IoT sensors alert for humidity/temp changes.",
    },
    {
      sentiment: "negative",
      question: "Slow retrieval times?",
      answer:
        "AI-sorted bays for instant access.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Pricing for storage slots?",
      answer:
        "Flexible rates by crop and duration.",
    },
    {
      sentiment: "neutral",
      question: "Link to transporters?",
      answer:
        "Integrated with Logistic for seamless handoffs.",
    },
    {
      sentiment: "neutral",
      question: "Inventory audits?",
      answer:
        "Daily scans and reports for accuracy.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to attract more clients?",
      answer:
        "Marketplace listings with capacity updates.",
    },
    {
      sentiment: "positive",
      question: "Will it boost efficiency?",
      answer:
        "Automation cuts labor, increases throughput.",
    },
    {
      sentiment: "positive",
      question: "Sustainable storage options?",
      answer:
        "Green certifications for eco-conscious sellers.",
    },
  ],
  "🚢 Export-Import": [
    // Negative
    {
      sentiment: "negative",
      question: "Regulatory paperwork is a nightmare?",
      answer:
        "AI auto-fills forms, compliant with global standards.",
    },
    {
      sentiment: "negative",
      question: "Finding international buyers tough?",
      answer:
        "Matched via Trade Insights and verified networks.",
    },
    {
      sentiment: "negative",
      question: "Currency fluctuations hurt?",
      answer:
        "Hedging tools and rate alerts protect margins.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Handle certifications?",
      answer:
        "Guides for organic/export docs with uploads.",
    },
    {
      sentiment: "neutral",
      question: "Track shipments globally?",
      answer:
        "End-to-end visibility from farm to port.",
    },
    {
      sentiment: "neutral",
      question: "Customs clearance support?",
      answer:
        "Partner agents for smooth borders.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to scale exports?",
      answer:
        "Bulk deals with Corporate buyers abroad.",
    },
    {
      sentiment: "positive",
      question: "Will it open new markets?",
      answer:
        "Targeted outreach to high-demand regions.",
    },
    {
      sentiment: "positive",
      question: "Profit from trends?",
      answer:
        "Data forecasts global demands for agri goods.",
    },
  ],
  "🍽️ Food Business": [
    // Negative
    {
      sentiment: "negative",
      question: "Sourcing traceable ingredients hard?",
      answer:
        "Farm-to-table chains with QR codes for origins.",
    },
    {
      sentiment: "negative",
      question: "Wastage from inconsistent supplies?",
      answer:
        "Predictive ordering reduces spoilage by 30%.",
    },
    {
      sentiment: "negative",
      question: "Food safety compliance overwhelming?",
      answer:
        "Built-in checklists and audit trails for regs.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Menu planning with seasonal crops?",
      answer:
        "Suggestions based on local harvests.",
    },
    {
      sentiment: "neutral",
      question: "Supplier negotiations?",
      answer:
        "Group buys via Unity Deals for better rates.",
    },
    {
      sentiment: "neutral",
      question: "Customer feedback integration?",
      answer:
        "Direct from Complaints to menu tweaks.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to innovate recipes?",
      answer:
        "AI Counselling for fusion agri ideas.",
    },
    {
      sentiment: "positive",
      question: "Boost sustainability cred?",
      answer:
        "Highlight Waste Disposer partnerships on menus.",
    },
    {
      sentiment: "positive",
      question: "Scale to chains?",
      answer:
        "Marketplace for franchising supplies.",
    },
  ],
  "🚮 Waste Disposer": [
    // Negative
    {
      sentiment: "negative",
      question: "Collection routes inefficient?",
      answer:
        "Optimized by AI for minimal travel and max pickups.",
    },
    {
      sentiment: "negative",
      question: "Low recycling value for agri waste?",
      answer:
        "Links to upcyclers turning waste into biogas/fuel.",
    },
    {
      sentiment: "negative",
      question: "Environmental regs strict?",
      answer:
        "Compliance trackers and green certifications provided.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Segregate waste types?",
      answer:
        "App-guided sorting at source with farms.",
    },
    {
      sentiment: "neutral",
      question: "Partner with farms?",
      answer:
        "Contract for regular disposals via platform.",
    },
    {
      sentiment: "neutral",
      question: "Report disposal metrics?",
      answer:
        "Auto-logs for impact and billing.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to monetize waste?",
      answer:
        "Sell recyclables through Marketplace.",
    },
    {
      sentiment: "positive",
      question: "Contribute to green goals?",
      answer:
        "Track carbon savings for NGO/Corporate credits.",
    },
    {
      sentiment: "positive",
      question: "Scale operations?",
      answer:
        "Cluster integrations for regional coverage.",
    },
  ],
  "🤝 NGO": [
    // Negative
    {
      sentiment: "negative",
      question: "How can we measure real impact in remote areas?",
      answer:
        "Real-time dashboards track farmer adoption, income uplift, and community metrics—ground truth, not estimates.",
    },
    {
      sentiment: "negative",
      question: "Will tech barriers limit our rural beneficiaries?",
      answer:
        "Voice-enabled, low-data design reaches even non-smartphone users—empowering from day one.",
    },
    {
      sentiment: "negative",
      question: "Is funding integration with schemes seamless?",
      answer:
        "Links to government programs like AgriInsurance, with automated reporting for grants.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Can we monitor multiple projects at once?",
      answer:
        "Custom dashboards for regions, crops, and impacts—scalable oversight.",
    },
    {
      sentiment: "neutral",
      question: "Does it support event and workshop tracking?",
      answer:
        "Agri Events module logs attendance and feedback automatically.",
    },
    {
      sentiment: "neutral",
      question: "How do we collaborate with corporates?",
      answer:
        "Shared access for partners, with co-branded initiatives.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "Can it amplify our sustainability efforts?",
      answer:
        "Community Impact tools track green metrics, attracting more donors.",
    },
    {
      sentiment: "positive",
      question: "Will AI help target interventions?",
      answer:
        "Identifies high-need farmers via data, maximizing your resources.",
    },
    {
      sentiment: "positive",
      question: "Can we scale nationwide?",
      answer:
        "From local pilots to national rollout—platform grows with you.",
    },
  ],
  "🏢 Corporate": [
    // Negative
    {
      sentiment: "negative",
      question: "How does this fit our CSR without extra admin?",
      answer:
        "Plug-and-play: Track impact via dashboards, no manual reporting needed.",
    },
    {
      sentiment: "negative",
      question: "Will supplier chains be truly transparent?",
      answer:
        "End-to-end traceability from farm to factory—audit-ready compliance.",
    },
    {
      sentiment: "negative",
      question: "Is ROI on partnerships measurable?",
      answer:
        "Analytics show cost savings, sustainability gains, and community uplift—clear metrics.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Can we integrate with our supply chain software?",
      answer:
        "APIs for ERP/CRM sync—seamless data flow.",
    },
    {
      sentiment: "neutral",
      question: "How do we select partner farmers?",
      answer:
        "AI matches based on capacity, certifications, and location.",
    },
    {
      sentiment: "neutral",
      question: "What reports are available for stakeholders?",
      answer:
        "Custom ESG reports, exportable for annual filings.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "Can it enhance our ethical sourcing?",
      answer:
        "Sustainable Growth features ensure fair-trade compliance and farmer welfare.",
    },
    {
      sentiment: "positive",
      question: "Will it reduce supply risks?",
      answer:
        "Predictive Insights flag disruptions early—stable chains.",
    },
    {
      sentiment: "positive",
      question: "Can we co-innovate with farmers?",
      answer:
        "Agri Innovations hub for joint R&D—drive mutual growth.",
    },
  ],
  "📚 Agri Scholar": [
    // Negative
    {
      sentiment: "negative",
      question: "Applying theory to real farms is hard?",
      answer:
        "Case studies and simulations bridge the gap—practical insights.",
    },
    {
      sentiment: "negative",
      question: "Limited field access for research?",
      answer:
        "Connect with Farmers via platform for collaborative studies.",
    },
    {
      sentiment: "negative",
      question: "Publishing agri papers slowly?",
      answer:
        "Digital sharing via Innovations hub accelerates visibility.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Access latest research data?",
      answer:
        "Curated feeds from global and local sources.",
    },
    {
      sentiment: "neutral",
      question: "Collaborate with experts?",
      answer:
        "Forums and POV for joint projects.",
    },
    {
      sentiment: "neutral",
      question: "Analyze field data?",
      answer:
        "Tools for stats and visualizations.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to influence policy?",
      answer:
        "Share insights with Government via reports.",
    },
    {
      sentiment: "positive",
      question: "Mentor young farmers?",
      answer:
        "Workshops platform for knowledge transfer.",
    },
    {
      sentiment: "positive",
      question: "Track research impact?",
      answer:
        "Metrics on adoptions and citations.",
    },
  ],
  "🚁 Drone Operators": [
    // Negative
    {
      sentiment: "negative",
      question: "Regs for drones too restrictive?",
      answer:
        "Guides and certification help navigate easily.",
    },
    {
      sentiment: "negative",
      question: "Finding farm clients sporadic?",
      answer:
        "Marketplace gigs match you to needs.",
    },
    {
      sentiment: "negative",
      question: "Data analysis time-consuming?",
      answer:
        "AI processes imagery for quick reports.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Compatible with farm tech?",
      answer:
        "Integrates with Digital Twin for seamless use.",
    },
    {
      sentiment: "neutral",
      question: "Pricing services?",
      answer:
        "Market rates with package options.",
    },
    {
      sentiment: "neutral",
      question: "Maintenance support?",
      answer:
        "Vendor links for parts and repairs.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to precision-farm services?",
      answer:
        "Boost yields with targeted spraying maps.",
    },
    {
      sentiment: "positive",
      question: "Earn from surveys?",
      answer:
        "Sell data insights to scholars.",
    },
    {
      sentiment: "positive",
      question: "Scale to fleets?",
      answer:
        "Cluster contracts for multi-drone ops.",
    },
  ],
  "🧑‍🔬 Expert": [
    // Negative
    {
      sentiment: "negative",
      question: "Reaching clients remotely hard?",
      answer:
        "Virtual consultations via platform.",
    },
    {
      sentiment: "negative",
      question: "Monetizing advice inconsistent?",
      answer:
        "Pay-per-session with secure billing.",
    },
    {
      sentiment: "negative",
      question: "Staying updated on trends?",
      answer:
        "Daily briefs and Podcasts.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Specialize in areas?",
      answer:
        "Profile tags for crop/pest expertise.",
    },
    {
      sentiment: "neutral",
      question: "Schedule sessions?",
      answer:
        "Calendar sync with farmers.",
    },
    {
      sentiment: "neutral",
      question: "Client feedback?",
      answer:
        "Ratings to build your rep.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to impact more farms?",
      answer:
        "Group workshops for scale.",
    },
    {
      sentiment: "positive",
      question: "Collaborate with corporates?",
      answer:
        "CSR projects for big reach.",
    },
    {
      sentiment: "positive",
      question: "Innovate solutions?",
      answer:
        "Hub for patenting agri tech.",
    },
  ],
  "🐄 Vet Doctor": [
    // Negative
    {
      sentiment: "negative",
      question: "Rural visits logistically tough?",
      answer:
        "Tele-vet with AI diagnostics aids.",
    },
    {
      sentiment: "negative",
      question: "Supply shortages for meds?",
      answer:
        "Stockist links for quick orders.",
    },
    {
      sentiment: "negative",
      question: "Tracking herd health manual?",
      answer:
        "Digital records with reminders.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Integrate with insurance?",
      answer:
        "Claims filing via AgriInsurance.",
    },
    {
      sentiment: "neutral",
      question: "Emergency alerts?",
      answer:
        "Geo-fenced notifications.",
    },
    {
      sentiment: "neutral",
      question: "Vaccine schedules?",
      answer:
        "Auto-planners for herds.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to prevent outbreaks?",
      answer:
        "Predictive analytics from data.",
    },
    {
      sentiment: "positive",
      question: "Educate farmers?",
      answer:
        "Counselling sessions on care.",
    },
    {
      sentiment: "positive",
      question: "Scale practice?",
      answer:
        "Cluster contracts for groups.",
    },
  ],
  "Wholesale Buyer": [
    // Negative
    {
      sentiment: "negative",
      question: "How reliable are the bulk supply volumes from farmers?",
      answer:
        "Contract Farming locks in volumes with AI predictions—reliable deliveries, no surprises.",
    },
    {
      sentiment: "negative",
      question: "Will price volatility still affect me on this platform?",
      answer:
        "Data-Driven Insights forecast trends, helping you lock deals early and hedge risks effectively.",
    },
    {
      sentiment: "negative",
      question: "Is logistics integration smooth for large orders?",
      answer:
        "Partnered with Logistic providers for tracked, Quick Delivery—minimize delays on big consignments.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Does it provide historical price data?",
      answer:
        "Yes, year-on-year trends by crop and region, accessible via dashboard.",
    },
    {
      sentiment: "neutral",
      question: "Can I filter suppliers by certifications?",
      answer:
        "Search by organic, sustainable, or location—easy matching for your needs.",
    },
    {
      sentiment: "neutral",
      question: "How do I handle bulk enquiries?",
      answer:
        "Centralized Enquiry system routes requests to verified suppliers instantly.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "Can it help me source ethically?",
      answer:
        "Trust & Transparency features show farm origins and sustainability scores.",
    },
    {
      sentiment: "positive",
      question: "Will AI suggest optimal suppliers?",
      answer:
        "Yes, based on quality, price, and proximity—save time on sourcing.",
    },
    {
      sentiment: "positive",
      question: "Can I scale to exports easily?",
      answer:
        "Import-Export tools handle docs and global buyers, opening new markets.",
    },
  ],
  "Retail Buyer": [
    // Negative
    {
      sentiment: "negative",
      question: "Sourcing variety without overpaying?",
      answer:
        "Nearby Deals compare prices instantly—best value always.",
    },
    {
      sentiment: "negative",
      question: "Stockouts frustrate customers?",
      answer:
        "Alerts for alternatives from multiple retailers.",
    },
    {
      sentiment: "negative",
      question: "Handling returns tedious?",
      answer:
        "Easy policy enforcement with digital proofs.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "Curate seasonal stock?",
      answer:
        "Trend forecasts for timely buys.",
    },
    {
      sentiment: "neutral",
      question: "Customer personalization?",
      answer:
        "Data on prefs for targeted offers.",
    },
    {
      sentiment: "neutral",
      question: "Multi-store management?",
      answer:
        "Central dashboard for all locations.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How to compete with big chains?",
      answer:
        "Local focus with Agri Events for loyalty.",
    },
    {
      sentiment: "positive",
      question: "Boost online presence?",
      answer:
        "Hybrid sales via Marketplace.",
    },
    {
      sentiment: "positive",
      question: "Sustainable sourcing cred?",
      answer:
        "Highlight ethical suppliers to eco-buyers.",
    },
  ],
  "Consumer Buyer": [
    // Negative
    {
      sentiment: "negative",
      question: "Are the products really fresh and safe?",
      answer:
        "Quick & Reliable delivery ensures farm-fresh arrival, with traceability from seed to shelf.",
    },
    {
      sentiment: "negative",
      question: "Why pay more for 'local' when supermarkets are cheaper?",
      answer:
        "Support farmers directly, get premium quality, and earn rewards—often cheaper with deals like Kharcho Jeeto.",
    },
    {
      sentiment: "negative",
      question: "What if delivery is delayed in my area?",
      answer:
        "ThinkXpress guarantees same-day in most areas, with refunds for delays—your satisfaction first.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How do I customize my shopping basket?",
      answer:
        "Create Basket lets you mix veggies, dairy, and more—personalized for your family.",
    },
    {
      sentiment: "neutral",
      question: "Is payment secure and flexible?",
      answer:
        "UPI, cards, or wallet— all encrypted, with easy returns.",
    },
    {
      sentiment: "neutral",
      question: "Can I track my orders in real-time?",
      answer:
        "Yes, live updates from farm to door via the app.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How does it support local farmers?",
      answer:
        "Every purchase via Support a Farmer boosts rural incomes—feel good about your grocery run.",
    },
    {
      sentiment: "positive",
      question: "Can I earn while shopping?",
      answer:
        "Rewarding Videos and Ads give points for prizes—shop smart, win big.",
    },
    {
      sentiment: "positive",
      question: "Will it help me eat healthier?",
      answer:
        "Curated seasonal picks and nutrition tips from AI Counselling—fresher, better choices.",
    },
  ],
};

// Color coding for sentiment
const sentimentColors = {
  negative: "text-orange-400",
  neutral: "text-gray-400",
  positive: "text-green-400",
};

export default function AgriLinkFAQHome() {
  const stakeholders = Object.keys(faqData);
  const [selectedStakeholder, setSelectedStakeholder] = useState(
    stakeholders[0]
  );
  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <div className="min-h-screen bg-black text-white p-4 sm:p-8">
      <h1 className="text-lg sm:text-xl font-bold mb-6 text-center">
        🌱 AgriLink FAQ
      </h1>

      {/* Stakeholder Tabs */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-2 mb-2 py-2 px-2 rounded-lg bg-gray-700 place-items-center">
        {stakeholders.map((stakeholder) => (
          <button
            key={stakeholder}
            onClick={() => {
              setSelectedStakeholder(stakeholder);
              setExpandedIndex(null);
            }}
            className={`px-4 py-2 rounded ${
              selectedStakeholder === stakeholder
                ? "bg-green-600 text-gray-900"
                : "bg-green-700 hover:bg-green-600"
            } font-semibold text-xs lg:text-m`}
          >
            {stakeholder}
          </button>
        ))}
      </div>

      {/* FAQ List */}
      <div className="mx-auto bg-gray-800 px-2 py-2 rounded-lg">
        <p className="text-lg text-center text-yellow-300 mb-2 border-b-2">{selectedStakeholder}</p>
        {faqData[selectedStakeholder].map((faq, index) => (
          <div
            key={index}
            className="border-b border-gray-700 py-3 cursor-pointer"
            onClick={() =>
              setExpandedIndex(expandedIndex === index ? null : index)
            }
          >
            <div className="flex justify-between items-center">
              <h3
                className={`font-medium text-xs lg:text-sm ${sentimentColors[faq.sentiment]}`}
              >
                {faq.question}
              </h3>
              <span className="text-gray-400 text-xs lg:text-m">
                {expandedIndex === index ? "-" : "+"}
              </span>
            </div>
            {expandedIndex === index && (
              <p className="mt-2 text-xs lg:text-m text-gray-300">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}